"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _host = require("../../host");
var _logger = require("../../logger");
class HostServiceMaacIE extends _host.HostService {
  constructor(props) {
    super(props);
    this.closeGuidedSellingModal = void 0;
    this.closeGuidedSellingModal = props.closeGuidedSellingModal;
  }
  addToCart(_ref) {
    var _addOnInfo$split;
    let {
      businessSolutionId
    } = _ref;
    const [productInfo, addOnInfo] = businessSolutionId.split('_');
    const businessSolutionEditionId = productInfo.split('-')[3];
    const businessSolutionAddOnEditionId = addOnInfo === null || addOnInfo === void 0 ? void 0 : (_addOnInfo$split = addOnInfo.split('-')) === null || _addOnInfo$split === void 0 ? void 0 : _addOnInfo$split[3];
    const event = new CustomEvent('AddToBasketEvent', {
      detail: [{
        productId: businessSolutionEditionId,
        qty: 1
      }, businessSolutionAddOnEditionId && {
        productId: businessSolutionAddOnEditionId,
        qty: 1
      }].filter(entry => entry)
    });
    document.dispatchEvent(event);
    try {
      this.closeGuidedSellingModal();
    } catch (error) {
      _logger.Logger.error({
        segments: [_logger.Logger.LOGGER_SEGMENTS.SERVICES]
      })(error);
    }
  }
}
var _default = HostServiceMaacIE;
exports.default = _default;